import _ from 'lodash';
import React from 'react';
import { Field } from '../../../types/FieldCommon';
import { UserSettingsCollapseKeys } from '../../../types/User';
import CustomInputFields from './CustomInputFields';
import AccordionSection from '../../AccordionSection';

interface IFieldSectionProps {
  fields: Field[];
  setFields: (fields: Field[]) => void;
  collapseId: UserSettingsCollapseKeys;
}

export default function FieldsSection({ fields, setFields, collapseId }: IFieldSectionProps) {
  const updateFieldValue = (label: string, value: any) => {
    const field: Field | undefined = _.find(fields, { label });
    if (!field) return;
    const newField: Field = {
      ...field,
      value,
    };
    setFields(_.map(fields, (f) => (f.label === label ? newField : f)));
  };

  return (
    <AccordionSection title="More Details" collapseId={collapseId}>
      <CustomInputFields fields={fields} updateFieldValue={updateFieldValue} />
    </AccordionSection>
  );
}
